import { useState } from "react";
import { PARTNER_LOGOS } from "@/components/PartnerLogos";

function LogoTile({ p }) {
  const [err, setErr] = useState(!p.logo);
  const slug = p.name.toLowerCase().replace(/[^a-z0-9]+/g, "-");
  return (
    <div
      data-testid={`trusted-logo-${slug}`}
      className="group flex h-24 items-center justify-center rounded-2xl border border-slate-100 bg-white px-5 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-md"
    >
      {err ? (
        <span className="text-center font-display text-sm font-bold leading-tight text-brandnavy">{p.name}</span>
      ) : (
        <img
          src={p.logo}
          alt={`${p.name} logo`}
          onError={() => setErr(true)}
          loading="lazy"
          className="max-h-11 max-w-[140px] object-contain opacity-70 grayscale transition-all duration-300 group-hover:opacity-100 group-hover:grayscale-0"
        />
      )}
    </div>
  );
}

export default function TrustedPartners({
  eyebrow = "Trusted Partners",
  title = "In good company.",
  subtitle = "We're proud to work alongside organizations that believe in preparing young people for real-world success.",
  dark = false,
}) {
  return (
    <section data-testid="trusted-partners-section" className={dark ? "bg-brandnavy py-20" : "bg-white py-20"}>
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-accent">{eyebrow}</span>
          <h2 className={`mt-3 font-display text-3xl sm:text-4xl font-black tracking-tight ${dark ? "text-white" : "text-brandnavy"}`}>
            {title}
          </h2>
          <p className={`mt-4 ${dark ? "text-slate-300" : "text-slate-600"}`}>{subtitle}</p>
        </div>
        <div className="mt-12 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {PARTNER_LOGOS.map((p) => (
            <LogoTile key={p.name} p={p} />
          ))}
        </div>
        <p className={`mt-8 text-center text-sm ${dark ? "text-slate-400" : "text-slate-500"}`}>
          Plus community outreach through <span className={dark ? "text-white font-semibold" : "text-slate-700 font-semibold"}>Feed the Family</span> and our annual <span className={dark ? "text-white font-semibold" : "text-slate-700 font-semibold"}>Secret Santa</span> initiatives.
        </p>
      </div>
    </section>
  );
}
